// PageTemplate.jsx
// Layout compartido para: Nuestra Historia, Filosofía, Ingredientes, Sostenibilidad
// Tipografía serif: Canela (importar en index.css o usar fallback Cormorant Garamond)

import React from 'react';
import './PageTemplate.css';

// ── Reusable sub-components ──

export const HeroSection = ({ category, title, meta }) => (
  <div className="pt-hero">
    <p className="pt-hero__category">{category}</p>
    <h1 className="pt-hero__title">{title}</h1>
    <span className="pt-hero__meta">{meta}</span>
  </div>
);

export const TextBlock = ({ heading, body }) => (
  <div className="pt-text-block">
    {heading && <p className="pt-text-block__heading">{heading}</p>}
    <p className="pt-text-block__body">{body}</p>
  </div>
);

export const StatementHeading = ({ text }) => (
  <h2 className="pt-statement">{text}</h2>
);

export const FullWidthImage = ({ src, alt }) => (
  src
    ? <img src={src} alt={alt || ''} className="pt-fullwidth-img" />
    : <div className="pt-fullwidth-placeholder" />
);

export const TwoColImages = ({ images = [null, null] }) => (
  <div className="pt-image-grid">
    {images.map((src, i) => (
      <div key={i} className="pt-image-grid__item">
        {src
          ? <img src={src} alt="" className="pt-image-grid__img" />
          : null}
      </div>
    ))}
  </div>
);

export const ProductGrid = ({ products = [] }) => (
  <div className="pt-product-grid">
    {products.map((p, i) => (
      <div key={i} className="pt-product-card">
        {p.badge && <p className="pt-product-card__badge">{p.badge}</p>}
        <button className="pt-product-card__wishlist" aria-label="Wishlist">♡</button>
        <div className="pt-product-card__img-wrap">
          {p.image
            ? <img src={p.image} alt={p.name} className="pt-product-card__img" />
            : <div style={{ width: 120, height: 160, backgroundColor: '#c8c6c0' }} />}
        </div>
        <p className="pt-product-card__name">{p.name}</p>
        {p.subtitle && <p className="pt-product-card__sub">{p.subtitle}</p>}
        {p.price && <p className="pt-product-card__price">{p.price}</p>}
      </div>
    ))}
  </div>
);

export const ContentSection = ({ children, narrow = false }) => (
  <div className="pt-section">
    <div className={narrow ? 'pt-section__narrow' : ''}>
      {children}
    </div>
  </div>
);

// data-header-theme="light": fondo claro → el menú mobile usa íconos oscuros
// (si no, quedaban blancos sobre blanco y no se veían).
export const PageWrapper = ({ children }) => (
  <div className="pt-page" data-header-theme="light">
    {children}
  </div>
);
